/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import { POST_SUBMITTED_APPLICATIONS_APPLICATION_PROGRAMS_ACES_WITHDRAWAL_REQUEST } from './actionTypes';

/**
 * Updates the details in the 'ACESWithdrawal' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postSubmittedApplicationsApplicationProgramsAcesWithdrawalRequestReducer = (
  state = {},
  action
) =>
  ReduxUtils.generateReducer(
    state,
    action,
    POST_SUBMITTED_APPLICATIONS_APPLICATION_PROGRAMS_ACES_WITHDRAWAL_REQUEST
  );

/**
 * Updates the indicator of creation of details in the 'ACESWithdrawal' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostSubmittedApplicationsApplicationProgramsAcesWithdrawalRequestReducer = (
  state = {},
  action
) =>
  ReduxUtils.generateFetchingReducer(
    state,
    action,
    POST_SUBMITTED_APPLICATIONS_APPLICATION_PROGRAMS_ACES_WITHDRAWAL_REQUEST
  );

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postSubmittedApplicationsApplicationProgramsAcesWithdrawalRequestErrorReducer = (
  state = {},
  action
) =>
  ReduxUtils.generateErrorReducer(
    state,
    action,
    POST_SUBMITTED_APPLICATIONS_APPLICATION_PROGRAMS_ACES_WITHDRAWAL_REQUEST
  );

const reducers = combineReducers({
  postSubmittedApplicationsApplicationProgramsAcesWithdrawalRequest:
    postSubmittedApplicationsApplicationProgramsAcesWithdrawalRequestReducer,

  isFetchingPostSubmittedApplicationsApplicationProgramsAcesWithdrawalRequest:
    isFetchingPostSubmittedApplicationsApplicationProgramsAcesWithdrawalRequestReducer,
  postSubmittedApplicationsApplicationProgramsAcesWithdrawalRequestError:
    postSubmittedApplicationsApplicationProgramsAcesWithdrawalRequestErrorReducer,
});

export default { reducers };
